export default "__VITE_ASSET__DG4p6ELh__"